var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"}),_c('notifications',{attrs:{"group":"notifications-bottom-right","position":"bottom right","classes":"custom-notification"}}),(_vm.loading)?_c('BlockUI',{attrs:{"id":"ui-loader-1234"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }